export class AiUploadBatchObjectCounts {
    categoryCounts: Record<string, number> = {};
    buildingsCount: number = 0;
    lvPolesCount: number = 0;
    dtPoleMountedCount: number = 0;
    dtGroundMountedCount: number = 0;
    mvPolesCount: number = 0;
    injectionSubstations: number = 0;
    hvPolesCount: number = 0;
    tsCount: number = 0;
    totalSegmentedObjectsCount: number = 0;

    constructor(data?: Record<string, number>) {
        if (data) {
            this.categoryCounts = data;
            this.buildingsCount = data['Building'] || 0;
            this.lvPolesCount = data['LvPole'] || 0;
            this.dtPoleMountedCount = data['DtPoleMounted'] || 0;
            this.dtGroundMountedCount = data['DtGroundMounted'] || 0;
            this.mvPolesCount = data['MvPole'] || 0;
            this.injectionSubstations = data['InjectionSubstation'] || 0;
            this.hvPolesCount = data['HvPole'] || 0;
            this.tsCount = data['TransmissionStation'] || 0;
        }
    }
}

export class BatchUploadPageInfo{
    pageInfo!: {
        pageSize: number | null,
        page: number | null
    }
    filterParams!:{
        category: CategoryType | null
    }
}

export enum CategoryType{
  ALL = 0,
  BUILDING = 1,
  LV_POLES = 2,
  MV_POLES = 3,
  HV_POLES = 4,
  DISTRIBUTION_TRANSFORMERS_POLE_MOUNTED = 5,
  DISTRIBUTION_TRANSFORMERS_GROUND_MOUNTED = 6,
  INJECTION_SUBSTATIONS = 7,
  TRANSMISSION_STATIONS = 8
}

export class BatchUploadObject{
    id!: number;
    objectId!: string;
    objectCategory!: CategoryType;
    type!: string;
    longitude!: string;
    latitude!: string;
    connectedAsset!: string;
    imageId!: string;
    generatedObjectId!: string;
}
